var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parseUnits } from 'ethers/lib/utils';
import { ChainId, NATIVE_SOL } from '@shared/utils/config/networks';
import { fetchEVMTokenBalances } from '@shared/utils/evm/fetchEVMTokenBalance';
import { fetchSVMTokenBalances } from '@shared/utils/solana/base/fetchSVMTokenBalances';
import buildAllPermit2Details from '@/lib/trade/buildAllPermit2Details';
export function getQuoteAndTransferParams(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var rawBalanceFlag, evmSVMBalances, rawBalance, amount, _c, permitBatchDetails, permitSignatures, _d, _transferParams, isNative, _quoteParams, error_1;
        var _e;
        var _f, _g, _h, _j, _k;
        var tokenUserBalance = _b.tokenUserBalance, PKP = _b.PKP, getEVMWallet = _b.getEVMWallet, form = _b.form, setParams = _b.setParams, refetch = _b.refetch, _formTokenAmount = _b._formTokenAmount, _formSendTo = _b._formSendTo, _formTokenUsdAmount = _b._formTokenUsdAmount;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _formTokenAmount = (_f = _formTokenAmount === null || _formTokenAmount === void 0 ? void 0 : _formTokenAmount.toString()) === null || _f === void 0 ? void 0 : _f.replace(',', '');
                    rawBalanceFlag = false;
                    if (!(parseFloat(_formTokenAmount) > (tokenUserBalance === null || tokenUserBalance === void 0 ? void 0 : tokenUserBalance.formatted_balance) * 0.99)) return [3 /*break*/, 5];
                    evmSVMBalances = void 0;
                    if (!(tokenUserBalance.network != ChainId.SOLANA)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchEVMTokenBalances({
                            network: tokenUserBalance.network,
                            tokens: [tokenUserBalance.contract_address],
                            owner: PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
                        })];
                case 1:
                    evmSVMBalances = _l.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchSVMTokenBalances({
                        network: tokenUserBalance.network,
                        tokens: [
                            tokenUserBalance.contract_name == 'Solana'
                                ? NATIVE_SOL
                                : tokenUserBalance.contract_address,
                        ],
                        owner: PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress,
                    })];
                case 3:
                    evmSVMBalances = _l.sent();
                    _l.label = 4;
                case 4:
                    rawBalance = evmSVMBalances[0].rawBalance;
                    _formTokenAmount = rawBalance === null || rawBalance === void 0 ? void 0 : rawBalance.toString();
                    rawBalanceFlag = true;
                    _l.label = 5;
                case 5:
                    console.log('SendFunds: getQuoteAndTransferParams: init', _formTokenAmount, _formSendTo);
                    _l.label = 6;
                case 6:
                    _l.trys.push([6, 9, , 10]);
                    if (!_formTokenAmount || isNaN(Number(_formTokenAmount))) {
                        return [2 /*return*/];
                    }
                    amount = void 0;
                    if (rawBalanceFlag) {
                        amount = _formTokenAmount;
                    }
                    else {
                        try {
                            amount = (_g = parseUnits(_formTokenAmount, tokenUserBalance.contract_decimals)) === null || _g === void 0 ? void 0 : _g.toString();
                        }
                        catch (e) {
                            amount = (_k = parseUnits((_j = (_h = parseFloat(_formTokenAmount)) === null || _h === void 0 ? void 0 : _h.toFixed(tokenUserBalance.contract_decimals)) === null || _j === void 0 ? void 0 : _j.toString(), tokenUserBalance.contract_decimals)) === null || _k === void 0 ? void 0 : _k.toString();
                        }
                    }
                    console.log('getQuote:amount', rawBalanceFlag, { p: parseFloat(_formTokenAmount), tokenUserBalance: tokenUserBalance, amount: amount }, _formSendTo);
                    _d = buildAllPermit2Details;
                    _e = {
                        tokensToApprove: [
                            {
                                network: tokenUserBalance.network,
                                contract_address: tokenUserBalance.contract_address,
                                amountToApprove: amount,
                            },
                        ]
                    };
                    return [4 /*yield*/, getEVMWallet()];
                case 7: return [4 /*yield*/, _d.apply(void 0, [(_e.ethersPKPWallet = _l.sent(),
                            _e)])];
                case 8:
                    _c = _l.sent(), permitBatchDetails = _c.permitBatchDetails, permitSignatures = _c.permitSignatures;
                    _transferParams = {
                        token_address: tokenUserBalance.contract_address,
                        token_amount: amount,
                        network: tokenUserBalance.network,
                        token_amount_formatted: parseFloat(amount) / Math.pow(10, tokenUserBalance.contract_decimals),
                        usd_value: parseFloat(_formTokenUsdAmount),
                        decimals: tokenUserBalance.contract_decimals,
                        symbol: tokenUserBalance.contract_ticker_symbol,
                        name: tokenUserBalance.contract_name,
                        image_thumb_url: tokenUserBalance.logo_url,
                        image_small_url: tokenUserBalance.logo_url,
                        image_large_url: tokenUserBalance.logo_url,
                        from_address: tokenUserBalance.network == ChainId.SOLANA ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
                        to_address: _formSendTo,
                    };
                    isNative = tokenUserBalance.network == ChainId.SOLANA && tokenUserBalance.contract_name == 'Solana';
                    _quoteParams = {
                        network: tokenUserBalance.network,
                        tokenAddress: isNative ? NATIVE_SOL : tokenUserBalance.contract_address,
                        tokenAmount: amount,
                        cloudWallet: tokenUserBalance.network == ChainId.SOLANA
                            ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress
                            : PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
                        receiver: _formSendTo,
                        permitBatchDetails: permitBatchDetails,
                        permitSignatures: permitSignatures,
                    };
                    form.setValue('transferParams', _transferParams);
                    setParams(_quoteParams);
                    refetch();
                    console.log('getQuoteAndTransferParams:', {
                        _transferParams: _transferParams,
                        _quoteParams: _quoteParams,
                    });
                    // // setQuoteParams(_quoteParams);
                    // return { _transferParams, _quoteParams };
                    return [2 /*return*/];
                case 9:
                    error_1 = _l.sent();
                    console.log('getQuoteAndTransferParams:error', { error: error_1 });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    });
}
